<tg-row *ngIf="showMessage">
    <tg-col md="8" sm="12">
        <tg-info-box>
            We will update your listing fee according to the new
            Capital value.
        </tg-info-box>
    </tg-col>
</tg-row>
